import React from "react";

const Sponsors = () => {
  const sponsors = [
    {
      tier: "الراعي الرئيسي",
      name: "nsave",
      icon: (
        <img
          src={`${process.env.PUBLIC_URL}/nsave_logo.png`}
          alt="nsave"
          className="w-3/4 m-auto"
        />
      ),
      colorClass: "bg-yellow",
      link: "https://nsave.com",
    },
    {
      tier: "التحكيم",
      name: "Google Developer Groups Egypt",
      icon: (
        <img
          src={`${process.env.PUBLIC_URL}/gdg-white.png`}
          alt="GDG Egypt"
          className="w-full m-auto"
        />
      ),
      colorClass: "bg-emerald-500",
      link: "https://gdg.community.dev/events/details/google-gdg-helwan-presents-qimma-hackathon/",
    },
    {
      tier: "الشريك الإبداعي",
      name: "Murvi",
      icon: (
        <img
          src={`${process.env.PUBLIC_URL}/Murvi-Logo.svg`}
          alt="Murvi"
          className="w-3/4 m-auto"
        />
      ),

      colorClass: "bg-purple",
      link: "https://instagram.com/themurvi",
    },
  ];

  return (
    <section className="relative py-20 md:py-32 bg-dark-blue overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 uppercase tracking-wide">
              الرعاة والشركاء 🤝
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-white/80">
              شكرًا لشركائنا الذين يدعمون المطورين العرب
            </p>
          </div>

          {/* Sponsors Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {sponsors.map((sponsor, index) => (
              <a
                href={sponsor.link}
                target="_blank"
                rel="noopener noreferrer"
                key={index}
                className={`group ${index === 0 ? "md:col-span-2" : ""} relative bg-white/5 rounded-3xl p-8 border border-white/10 hover:border-white/30 flex flex-col items-center justify-center transition-all  hover:scale-105`}
              >
                {/* Tier Badge */}
                <div
                  className={`absolute -top-4 right-6 px-4 py-2 rounded-full font-semibold text-sm text-dark-blue ${sponsor.colorClass}`}
                >
                  {sponsor.tier}
                </div>

                {/* Content */}
                <div className="mt-4">
                  <div className="text-6xl mb-4 text-center">
                    {sponsor.icon}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
